export default __webpack_public_path__ + "static/media/CVC Card.ced4c029.svg";